import React from 'react';
import ErrorsTable from '../components/tables/ErrorsTable';

const Errors: React.FC = () => {
  return (
    <div className="container mx-auto p-6">
      <h2>Errores</h2>
      <ErrorsTable />
    </div>
  );
};

export default Errors;